// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-header {
    width: 100%;
    padding-top: 100px;
    border-bottom: 1px solid #323232;
    text-align: center;
    padding-bottom: 10px;
}

.login-header:after {
    content: '';
    display: block;
    width: 100%;
    height: 3px;
    background: #323232;
    margin: 0 auto;
    position: relative;
    top: 12px;
}

.login-header img, .main-header img {
    cursor: pointer;
}

.main-header img {
    width: 261px;
}

.main-header {
    width: 80%;
    margin: 32px auto 0 auto;
    border-bottom: 2px solid #323232;
}

.logo_nav_pkg_admin {
    display: flex;
    flex-direction: column;
    margin-bottom: 64px;
    align-items: flex-start;
}

.logo_nav_pkg_dealer, .logo_nav_pkg_financial, .logo_nav_pkg_agency {
    align-items: center;
    justify-content: space-between;
    display: flex;
    margin-bottom: 64px;
}

@media screen and (max-width: 900px) {
    .login-header .smithLogo {
        width: 300px;
    }

    .main-header .smithLogo {
        width: 220px;
    }

    .logo_nav_pkg_dealer, .logo_nav_pkg_financial, .logo_nav_pkg_agency {
        padding: 0 3vw;
    }
}

@media screen and (max-width: 600px) {
    .login-header .smithLogo {
        width: 60%;
    }

    .logo_nav_pkg_admin {
        flex-direction: row;
        margin-bottom: 64px;
        align-items: center;
        justify-content: space-between;
        padding: 0 3vw;
    }

    .main-header {
        width: 100%;
    }

    .main-header .smithLogo {
        width: 180px;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/Header.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,kBAAkB;IAClB,gCAAgC;IAChC,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,wBAAwB;IACxB,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI;QACI,YAAY;IAChB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;QACI,mBAAmB;QACnB,mBAAmB;QACnB,mBAAmB;QACnB,8BAA8B;QAC9B,cAAc;IAClB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,YAAY;IAChB;AACJ","sourcesContent":[".login-header {\n    width: 100%;\n    padding-top: 100px;\n    border-bottom: 1px solid #323232;\n    text-align: center;\n    padding-bottom: 10px;\n}\n\n.login-header:after {\n    content: '';\n    display: block;\n    width: 100%;\n    height: 3px;\n    background: #323232;\n    margin: 0 auto;\n    position: relative;\n    top: 12px;\n}\n\n.login-header img, .main-header img {\n    cursor: pointer;\n}\n\n.main-header img {\n    width: 261px;\n}\n\n.main-header {\n    width: 80%;\n    margin: 32px auto 0 auto;\n    border-bottom: 2px solid #323232;\n}\n\n.logo_nav_pkg_admin {\n    display: flex;\n    flex-direction: column;\n    margin-bottom: 64px;\n    align-items: flex-start;\n}\n\n.logo_nav_pkg_dealer, .logo_nav_pkg_financial, .logo_nav_pkg_agency {\n    align-items: center;\n    justify-content: space-between;\n    display: flex;\n    margin-bottom: 64px;\n}\n\n@media screen and (max-width: 900px) {\n    .login-header .smithLogo {\n        width: 300px;\n    }\n\n    .main-header .smithLogo {\n        width: 220px;\n    }\n\n    .logo_nav_pkg_dealer, .logo_nav_pkg_financial, .logo_nav_pkg_agency {\n        padding: 0 3vw;\n    }\n}\n\n@media screen and (max-width: 600px) {\n    .login-header .smithLogo {\n        width: 60%;\n    }\n\n    .logo_nav_pkg_admin {\n        flex-direction: row;\n        margin-bottom: 64px;\n        align-items: center;\n        justify-content: space-between;\n        padding: 0 3vw;\n    }\n\n    .main-header {\n        width: 100%;\n    }\n\n    .main-header .smithLogo {\n        width: 180px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
